import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import * as Raven from 'raven-js';
import { clone } from 'lodash';

import { environment } from '../../environments/environment';
import { User } from '../users/user';
import { Provider } from '../providers/provider';
import { parseErrors, requestHeaders } from './api.service';
import { DataService } from './data.service';

const camelcaseKeysDeep = require('camelcase-keys-deep');
const decamelizeKeysDeep = require('decamelize-keys-deep');

@Injectable()
export class AuthenticationService {
  public key: string;
  private loggedIn = false;
  baseUrl = environment.serverUrl;

  constructor(
    private http: Http,
    private dataService: DataService
  ) {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.key = currentUser && currentUser.key;
  }

  register(model) {
    let params = clone(model);
    params = decamelizeKeysDeep(params);

    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('x-app-uuid', '560f2e3b-b3ae-4d18-9164-bffeefbe6c63');

    return this.http.post(this.baseUrl + 'rest-auth/registration/', params, { headers: headers })
      .map(this.extractData)
      .map(this.storeUser);
  }

  login(email: string, password: string): Observable<boolean> {
    let params = { email: email, password: password };
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('x-app-uuid', '560f2e3b-b3ae-4d18-9164-bffeefbe6c63');

    return this.http.post(this.baseUrl + 'rest-auth/login/', params, { headers: headers })
      .map(this.extractData)
      .map(this.storeUser);
  }

  confirm(token: string): Observable<boolean> {
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('x-app-uuid', '560f2e3b-b3ae-4d18-9164-bffeefbe6c63');

    return this.http.get(this.baseUrl + 'verify-email/' + token + '/', {
      headers: headers
    }).map(this.extractData).map(this.storeUser);
  }

  logout(): void {
    this.key = null;
    this.loggedIn = false;
    this.dataService.changeData({ authenticated: false });
    localStorage.removeItem('currentUser');
    Raven.setUserContext();
  }

  forgot(email: string): Observable<boolean> {
    let params = { email: email };
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('x-app-uuid', '560f2e3b-b3ae-4d18-9164-bffeefbe6c63');

    return this.http.post(this.baseUrl + 'rest-auth/password/reset/', params, { headers: headers })
      .map((response: Response) => {
        if (response) {
          if (response.status === 201 || response.status === 200) {
            return true;
          } else {
            return false;
          }
        }
      });
  }

  forgotUsername(phoneNumber: string): Observable<boolean> {
    let params = { phoneNumber: phoneNumber };
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('x-app-uuid', '560f2e3b-b3ae-4d18-9164-bffeefbe6c63');

    return this.http.post(this.baseUrl + 'rest-auth/forgot-username/', params, { headers: headers })
      .map((response: Response) => {
        if (response) {
          if (response.status === 201 || response.status === 200) {
            return true;
          } else {
            return false;
          }
        }
      });
  }

  change(key: string, uid: string, password: string): Observable<boolean> {
    let params = { key: key, uid: uid, password: password };
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.baseUrl + 'rest-auth/password/change/', params, { headers: headers })
      .map((response: Response) => {
        if (response) {
          if (response.status === 201 || response.status === 200) {
            return true;
          } else {
            return false;
          }
        }
      });
  }

  isLoggedIn(): boolean {
    let storedUser = localStorage.getItem('currentUser');
    let currentUser = storedUser && JSON.parse(storedUser);
    if (currentUser && currentUser.key) {
      this.loggedIn = true;
    }

    return this.loggedIn;
  }

  displaySidebar(): boolean {
    let storedUser = localStorage.getItem('currentUser');
    let currentUser = storedUser && JSON.parse(storedUser);
    if (currentUser && currentUser.key && currentUser.provider) {
      return true;
    }

    return false;
  }

  displayToolbar(): boolean {
    let storedUser = localStorage.getItem('currentUser');
    let currentUser = storedUser && JSON.parse(storedUser);
    if (currentUser && currentUser.key && currentUser.provider) {
      return true;
    }

    return false;
  }

  user() {
    let storedUser = localStorage.getItem('currentUser');
    let currentUser = storedUser && JSON.parse(storedUser);
    return currentUser;
  }

  updateUserState(status) {
    let user = this.user();

    if (user) {
      let providerId = user.provider && user.provider.id;
      return this.http.patch(this.baseUrl + 'providers/' + providerId + '/', {
        status: status
      }, { headers: requestHeaders() }).map(this.extractProfileData).map(this.storeProvider);
    } else {
      // return true;
    }
  }

  updateProvider(provider): void {
    let user = this.user();
    if (user) {
      let _provider = new Provider(provider);
      this.storeProvider(_provider);
    } else {
      // return true;
    }
  }

  private extractData(res: Response) {
    let body = res.json().results;
    if (body) {
      return body.map(user => {
        user = camelcaseKeysDeep(user);
        return new User(user);
      });
    } else if (res.json()) {
      let user = camelcaseKeysDeep(res.json());
      // TODO: Remove once key is part of user object
      if (user && user.hasOwnProperty('user')) {
        let key = user['key'];
        user = user['user'];
        user['key'] = key;
      }
      return new User(user);
    } else {
      return [];
    }
  }

  private storeUser(user: User) {
    if (user.key) {
      this.key = user.key;
      localStorage.setItem('currentUser', JSON.stringify({
        username: user.email, key: user.key, name: user.name,
        id: user.id, image: user.image, status: user.status,
        provider: user.provider
      }));
      this.loggedIn = true;
      Raven.setUserContext({ id: user.id, email: user.email });
      return true;
    } else {
      this.loggedIn = true;
      return false;
    }
  }

  private extractProfileData(res: Response) {
    let body = res.json().results;
    if (body) {
      return body.map(provider => {
        provider = camelcaseKeysDeep(provider);
        return new Provider(provider);
      });
    } else if (res.json()) {
      let provider = camelcaseKeysDeep(res.json());
      return new Provider(provider);
    } else {
      return [];
    }
  }

  private storeProvider(provider: Provider) {
    let storedUser = localStorage.getItem('currentUser');
    let user = storedUser && JSON.parse(storedUser);

    if (user) {
      localStorage.setItem('currentUser', JSON.stringify({
        username: user.email, key: user.key, name: user.name,
        id: user.id, image: user.image, status: provider.status,
        provider: provider
      }));
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/authentication.service.ts